export function saveAs(data: Blob, fileName: string): void {
    const blobUrl = URL.createObjectURL(data);
    const anchor = document.createElement('a');

    anchor.href = blobUrl;
    anchor.download = fileName;

    anchor.click();

    URL.revokeObjectURL(blobUrl);
}
